import { AccountLockOpenOutlineIcon } from './AccountLockOpenOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 0E6C1E1C-7F80-445A-92CB-230F04F09093
 * name account-lock-open-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-lock-open-outline.svg
 * tags
 * - Account / User 
 * - Lock 
 */
export const UserLockOpenOutlineIcon = AccountLockOpenOutlineIcon;
export default UserLockOpenOutlineIcon